export default "__VITE_ASSET__334ee9e9__"